// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:16:44

export default {
  "id": "imposter-3d-1",
  "slug": "imposter-3d-1",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/f53b4fb00a184b0db1082c683837bbeb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/f53b4fb00a184b0db1082c683837bbeb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Imposter 3D",
      "description": "Brace yourself for a thrilling challenge! Tap the screen to release balls and guide them into the holes each round. Afterward, head to the store to snag upgrades and cool items to power up your game. Complete levels, gather diamonds, and unlock permanent upgrades to boost your progress. How far can you take your skills? The further you go, the greater the rewards!",
      "instructions": "Desktop:\n- move around the level with the mouse.\nMobile:\n- move around the level with the joystick.\n\nControls (general):\n- to kill an enemy, just get close to him;\n- if you are a \"Hero\", avoid the enemy's line of sight (red cone);\n- if you are a \"Killer\", save your partner from the cage (to do this, go into the cage).",
      "genres": [
        "Battle",
        "Casual"
      ],
      "tags": [
        "arcade",
        "impostor"
      ]
    },
    "zh-CN": {
      "title": "冒充者3D",
      "description": "准备好迎接一场刺激的挑战！点击屏幕释放球体，并在每一轮引导它们进入洞中。之后，前往商店获取升级和酷炫物品来增强你的游戏。完成关卡，收集钻石，解锁永久升级以提升你的进度。你能将你的技能发挥到何种程度？走得越远，奖励越丰厚！",
      "instructions": "桌面：\n- 使用鼠标在关卡中移动。\n移动设备：\n- 使用摇杆在关卡中移动。\n\n控制（通用）：\n- 杀死敌人，只需靠近他；\n- 如果你是“英雄”，避免敌人的视线（红色锥形区域）；\n- 如果你是“杀手”，从笼子里救出你的伙伴（为此，进入笼子）。",
      "genres": [
        "战斗",
        "休闲"
      ],
      "tags": [
        "街机",
        "冒充者"
      ]
    },
    "zh-TW": {
      "title": "冒充者3D",
      "description": "準備好迎接刺激的挑戰！點擊螢幕釋放球體，並將其引導進每回合的洞中。之後，前往商店抓取升級和酷炫道具來提升你的遊戲。完成關卡，收集鑽石，並解鎖永久升級來推進你的進度。你能將你的技能帶到多遠？越往前進，獎勵越豐厚！",
      "instructions": "桌面：\n- 使用滑鼠在關卡中移動。\n行動裝置：\n- 使用搖桿在關卡中移動。\n\n控制鍵（一般）：\n- 要殺死敵人，只需靠近他；\n- 如果你是「英雄」，避免敵人的視線範圍（紅色光锥）；\n- 如果你是「殺手」，從籠子中救出你的夥伴（為此，進入籠子）。",
      "genres": [
        "戰鬥",
        "隨便"
      ],
      "tags": [
        "街機",
        "偽裝者"
      ]
    },
    "zh-HK": {
      "title": "冒充者3D",
      "description": "為了一個刺激挑戰準備好自己！按擊螢幕釋放球體並將它們導入每回合的洞中。完成後，前往商店搶購升級項目和炫酷道具來提升你的遊戲。完成等級，收集鑽石，解鎖永久升級以加速進度。你能把你的技能帶到多遠？走得越遠，獎勵越豐厚！",
      "instructions": "桌面：\n- 用滑鼠在級別內移動。\n流动式：\n- 用搖桿在級別內移動。\n\n控制（一般）：\n- 欲殺死敵人，只需靠近他；\n- 若你是「英雄」，避免敵人的視線範圍（紅色錐形區域）；\n- 若你是「殺手」，救出你的夥伴從籠中（為此，進入籠中）。",
      "genres": [
        "戰鬥",
        "輕鬆"
      ],
      "tags": [
        "街機",
        "偽裝者"
      ]
    },
    "ja": {
      "title": "偽者3D",
      "description": "自分を緊張させて、刺激的な挑戦に備えてください！スクリーンをタップしてボールを放ち、それぞれのラウンドで穴に導いてください。その後、ストアに行ってアップグレードやクールなアイテムを手に入れ、ゲームを強化してください。レベルを完了し、ダイヤモンドを集め、永続的なアップグレードを解鎖して進捗を促進してください。あなたのスキルをどれだけ高められるでしょうか？さらに進むほど、より大きな報酬が待っています！",
      "instructions": "デスクトップ:\n- マウスを使ってレベル内を移動します。\nモバイル:\n- ジョYSTICKを使ってレベル内を移動します。\n\nコントロール（一般）:\n- 敵を殺すには、ただ敵に近づくだけで良い；\n- 「ヒーロー」の場合、敵の視線（赤い円錐）を避けます；\n- 「キラー」の場合、パートナーを柵から救出します（これを行うには、柵に入ります）。",
      "genres": [
        "バトル",
        "カジュアル"
      ],
      "tags": [
        "アーケード",
        "イミタート"
      ]
    },
    "ko": {
      "title": "거짓말쟁이 3D",
      "description": "자신을 준비하세요! 흥미진진한 도전에 직면하세요! 화면을 탭하여 공을 방출하고 각 라운드마다 구멍에 이동시켜주세요. 이후, 상점으로 가서 업그레이드와 다양한 아이템을 사서 게임을 강화하세요. 레벨을 완료하고 다이아몬드를 모아 영구적인 업그레이드를 해서 진행을 촉진하세요. 자신의 기술을 얼마나 멀리 끌 수 있을까요? 더 멀리 가면 보상도 더 큽니다!",
      "instructions": "데스크톱:\n- 마우스로 레벨을 돌아다니십시오.\n모바일:\n- 조이스틱으로 레벨을 돌아다니십시오.\n\n컨트롤(일반):\n- 적을 죽이려면 그에게 다가가세요;\n- \"Hero\"이시라면 적의 시야(빨간 구면)를 피하세요;\n- \"Killer\"이시라면 동료를 캐지에서 구해내세요(이를 위해 캐지에 들어가세요).",
      "genres": [
        "전투",
        "일반"
      ],
      "tags": [
        "아케이드",
        "가장자리 인포스터"
      ]
    },
    "fr": {
      "title": "Imitateur 3D",
      "description": "Préparez-vous à un défi palpitant ! Tappez sur l'écran pour libérer des balles et guidez-les dans les trous à chaque tour. Ensuite, allez à la boutique pour obtenir des améliorations et des articles sympas pour renforcer votre jeu. Terminez les niveaux, collectez des diamants et débloquez des améliorations permanentes pour accélérer votre progression. Jusqu'où pouvez-vous pousser vos compétences ? Plus vous avancez, plus les récompenses sont grandes !",
      "instructions": "Desktop :\n- se déplacer dans le niveau avec la souris.\nMobile :\n- se déplacer dans le niveau avec le manette de jeu.\n\nContrôles (généraux) :\n- pour tuer un ennemi, approche-le simplement ;\n- si vous êtes un \"Héros\", évitez la ligne de vue de l'ennemi ( cône rouge ) ;\n- si vous êtes un \"Tueur\", sauvez votre partenaire de la cage (pour cela, entrez dans la cage).",
      "genres": [
        "Bataille",
        "Occasionnel"
      ],
      "tags": [
        "arcade",
        "imposteur"
      ]
    }
  }
};
